const projectFlagState = Object.freeze({
  ENABLED: 1,
  DISABLED: 0
})

export { projectFlagState }



// WEBPACK FOOTER //
// ./src/modules/project/enum/ProjectFlagStateEnum.js